"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROPER = void 0;
exports.PROPER = {
    alias: 'INICIALMAIUSCULA',
    description: 'Coloca a primeira letra do texto em maiúscula e todas as outras letras do texto depois de qualquer carácter diferente de uma letra. Converte todas as outras letras para minúsculas.',
    arg_names: ['string_to_transform'],
    args_description: ['texto que será transformado'],
};
